<template>
  <div>
    <el-upload
      v-loading.fullscreen.lock="loading"
      class="avatar-uploader"
      element-loading-text="上传中"
      action=""
      :show-file-list="false"
      :before-upload="beforeAvatarUpload"
      :on-error="onError"
      :http-request="handleRequest"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <i v-else class="el-icon-plus avatar-uploader-icon" />
    </el-upload>
  </div>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
export default {
  name: 'FileUpload',
  mixins: [CosMixin],
  model: { prop: 'imageUrl', event: 'onSuccess' },
  props: {
    imageUrl: {
      type: String,
      default: '',
    },
    fileTypeBeJpg: {
      type: Boolean,
      default: false,
    },
    fileSize: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    // 上传图片
    async handleRequest(file) {
      console.log(666, file);
      try {
        const cosParams = {
          fileObject: file.file,
        };
        const res = await this.putCosObject(cosParams);
        console.log(res, 'cos-res======>');
        this.$emit('onSuccess', res.data);
        this.loading = false;
        this.$message.success('上传成功');
      } catch (err) {
        this.loading = false;
        this.$message.error('上传失败');
        console.log('error', err);
      }
    },
    onError(e) {
      this.$emit('onError', e);
      this.loading = false;
    },
    onSuccess(file) {
      const img = file.ResultDate.cos_file_url;
      this.$emit('onSuccess', img);
      this.loading = false;
      this.$message.success('上传成功');
    },
    beforeAvatarUpload(file) {
      this.loading = true;
      const isJPG = file.type === 'image/jpeg';
      const isPNG = file.type === 'image/png';
      const isPG = this.fileTypeBeJpg ? isJPG || isPNG : isPNG;
      const isLt2M = file.size / 1024 / 1024 < this.fileSize;
      if (!isPNG && !this.fileTypeBeJpg) {
        this.$message.error('上传图片只能是 png 格式!');
        this.$emit('beforeAvatarUpload', false);
        this.loading = false;
      }
      if (!isPG && this.fileTypeBeJpg) {
        this.$message.error('上传图片只能是 jpg/png 格式!');
        this.$emit('beforeAvatarUpload', false);
        this.loading = false;
      }
      if (!isLt2M) {
        this.$message.error(
          `上传图片大小不能超过 ${
            this.fileSize > 1 ? `${this.fileSize}mb` : `${this.fileSize * 1000}kb`
          }!`,
        );
        this.loading = false;
      }
      return isPG && isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
.avatar-uploader ::v-deep.el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}

.avatar {
  position: relative;
  width: 250px;
  height: 100px;
  border-radius: 8px;
}
</style>
